<template>
  <div class="oc-logo" :class="{animated: animated}">
    <div class="oc-circle l1 s1 el1"></div>

    <div class="oc-circle l2 s3 el2"></div>
    <div class="oc-circle l2 s2 el3"></div>
    <div class="oc-circle l2 s2 el4"></div>

    <div class="oc-circle l3 s2 el5"></div>
    <div class="oc-circle l3 s2 el6"></div>

    <div class="oc-circle l4 s3 el7"></div>
    <div class="oc-circle l4 s2 el8"></div>
    <div class="oc-circle l4 s3 el9"></div>
  </div>
</template>

<script>

export default {
  name: 'oc-logo',
  props: {
    animated: {
      type: Boolean,
      default: 'false'
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'oc-logo';
</style>
